import { useModel, Workflow } from "@bcm-dev/bcms-vite";
import React from "react";

import ChatPage from "components/pages/ChatPage";
import LoginPage from "components/pages/LoginPage";
import ChatItem from "./classes/ChatItem";
import FullScreenChatPage from "components/pages/FullScreenChatPage";

// Steps of the workflow
let steps = [ LoginPage, ChatPage ];
// The constructor to use when using the 'force-workflow-state' event
const constructor = record => {
    const messages = record.messages.map(item => new ChatItem(item), []);
    return { ...record, "messages" : messages };
};

/**
 * @function ChatWorkflow
 * @returns {React.Component}
 * @description Returns the chat workflow main component
 * @exported true
 */
export default function ChatWorkflow(props) {
    const value = getDefaultData();
    const { branding } = useModel();
    const { options } = branding;
    const chatVersion = options.chat_version_abi22 === "undefined" ? "Chat Box" : options.chat_version_abi22;
    
    if(chatVersion === "Full Screen") {
        steps = [ LoginPage, FullScreenChatPage ];
    }
    
    return <Workflow value={ value } steps={ steps } constructor={ constructor }/>
}

/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @description Returns the steps of the workflow
 * @exported true
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefaultChat
 * @returns {OBJECT}
 * @description Returns the default state data for the workflow
 * @exported true
 */
export const getDefaultData = () => {
    return {
        "sessionHasEnded" : false,
        "messages" : [],
        "showInitialMessage" : true
    };
}